export enum SubCategoryName {
    RENT = 'RENT',
    HOUSE_LOAN = 'HOUSE_LOAN',
    ENERGY = 'ENERGY',
    UTILITY_BILLS = 'UTILITY_BILLS',
    WASTE_DISPOSAL = 'WASTE_DISPOSAL',
    SEWER_FEES = 'SEWER_FEES',
    INSURANCE = 'INSURANCE',
    FURNITURE = 'FURNITURE',
    IMPROVEMENTS_AND_FURNITURE = 'IMPROVEMENTS_AND_FURNITURE',
    CLEANING = 'CLEANING',
    PET_CARE = 'PET_CARE',
    OTHER_LIVING_AND_ENERGY = 'OTHER_LIVING_AND_ENERGY',
    FOOD_SHOPPING = 'FOOD_SHOPPING',
    RESTAURANT = 'RESTAURANT',
    OTHER_FOOD = 'OTHER_FOOD',
    DRUGSTORE = 'DRUGSTORE',
    PHARMACY = 'PHARMACY',
    COSMETICS = 'COSMETICS',
    DOCTORS_HOSPITAL = 'DOCTORS_HOSPITAL',
    LIFE_HEALTH_INSURANCE = 'LIFE_HEALTH_INSURANCE',
    OTHER_HEALTH = 'OTHER_HEALTH',
    FASHION = 'FASHION',
    SHOES = 'SHOES',
    ACCESSORIES = 'ACCESSORIES',
    OTHER_CLOTHING = 'OTHER_CLOTHING',
    PHONE_BILLS = 'PHONE_BILLS',
    TELEVISION = 'TELEVISION',
    INTERNET = 'INTERNET',
    ENTERTAINMENT_ELECTRONICS = 'ENTERTAINMENT_ELECTRONICS',
    AMUSEMENT = 'AMUSEMENT',
    HOBBIES_SPORT = 'HOBBIES_SPORT',
    HOBBIES_COTTAGE_GARDEN = 'HOBBIES_COTTAGE_GARDEN',
    READING = 'READING',
    TOYS_GAMES = 'TOYS_GAMES',
    TOBACCONIST = 'TOBACCONIST',
    BETTING = 'BETTING',
    OTHER_LEISURE = 'OTHER_LEISURE',
    KINDERGARTEN_SCHOOL_UNIVERSITY = 'KINDERGARTEN_SCHOOL_UNIVERSITY',
    BOOKS_SUPPLIES = 'BOOKS_SUPPLIES',
    TUITION = 'TUITION',
    OTHER_EDUCATION = 'OTHER_EDUCATION',
    CAR_PURCHASE_LOAN = 'CAR_PURCHASE_LOAN',
    GAS_FUEL = 'GAS_FUEL',
    CAR_MAINTENANCE = 'CAR_MAINTENANCE',
    CAR_INSURANCE = 'CAR_INSURANCE',
    PARKING = 'PARKING',
    TOLLS = 'TOLLS',
    OTHER_CAR = 'OTHER_CAR',
    PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT',
    TAXI = 'TAXI',
    OTHER_TRANSPORT = 'OTHER_TRANSPORT',
    HOLIDAY_ACCOMODATION = 'HOLIDAY_ACCOMODATION',
    HOLIDAY_FOOD_DRINKS = 'HOLIDAY_FOOD_DRINKS',
    HOLIDAY_EXPENSES = 'HOLIDAY_EXPENSES',
    FOREIGN_CURRENCY = 'FOREIGN_CURRENCY',
    OTHER_HOLIDAY = 'OTHER_HOLIDAY',
    ATM_WITHDRAWAL = 'ATM_WITHDRAWAL',
    BRANCH_WITHDRAWAL = 'BRANCH_WITHDRAWAL',
    CREDIT_CARD_WITHDRAWAL = 'CREDIT_CARD_WITHDRAWAL',
    CREDIT_CARD_BILL = 'CREDIT_CARD_BILL',
    QUICK_CHARGING = 'QUICK_CHARGING',
    OTHER_WITHDRAWAL = 'OTHER_WITHDRAWAL',
    POCKET_MONEY = 'POCKET_MONEY',
    ALIMONEY = 'ALIMONEY',
    OTHER_ALIMONY_POCKET_MONEY = 'OTHER_ALIMONY_POCKET_MONEY',
    UNCATEGORIZED_ONLINE_SHOPPING = 'UNCATEGORIZED_ONLINE_SHOPPING',
    SAVINGS = 'SAVINGS',
    BUILDING_SOCIETY = 'BUILDING_SOCIETY',
    CAPITALIZATION_PRODUCTS = 'CAPITALIZATION_PRODUCTS',
    SECURITIES = 'SECURITIES',
    OTHER_SAVINGS = 'OTHER_SAVINGS',
    PERSONAL_INCOME_TAX = 'PERSONAL_INCOME_TAX',
    VALUE_ADDED_TAX = 'VALUE_ADDED_TAX',
    OTHER_TAXES = 'OTHER_TAXES',
    INTERNAL_TRANSFERS = 'INTERNAL_TRANSFERS',
    FEES = 'FEES',
    INTERESTS = 'INTERESTS',
    LENDING = 'LENDING',
    OTHER_FEES = 'OTHER_FEES',
    FINANCING = 'FINANCING',
    INSURANCE_PREMIUM = 'INSURANCE_PREMIUM',
    UNKNOWN_INSURANCE = 'UNKNOWN_INSURANCE',
    SOCIAL_INSURANCE = 'SOCIAL_INSURANCE',
    GIFTS = 'GIFTS',
    DONATIONS = 'DONATIONS',
    PENALTIES_GOVERNMENTS = 'PENALTIES_GOVERNMENTS',
    OTHER_FINANCING = 'OTHER_FINANCING',
    UNCATEGORIZED_EXPENSE = 'UNCATEGORIZED_EXPENSE',
    SALARY = 'SALARY',
    PENSION = 'PENSION',
    BUSINESS_INCOME = 'BUSINESS_INCOME',
    UNEMPLOYMENT_COMPENSATION = 'UNEMPLOYMENT_COMPENSATION',
    MATERNITY_LEAVE = 'MATERNITY_LEAVE',
    FAMILY_ALLOWANCE = 'FAMILY_ALLOWANCE',
    ALIMONY = 'ALIMONY',
    OTHER_REGULAR_INCOME = 'OTHER_REGULAR_INCOME',
    EXTERNAL_TRANSFERS_INCOMING = 'EXTERNAL_TRANSFERS_INCOMING',
    RENTAL = 'RENTAL',
    CASH_DEPOSIT = 'CASH_DEPOSIT',
    OVERTIME_TRAVEL_COMPENSATION = 'OVERTIME_TRAVEL_COMPENSATION',
    INTERNAL_TRANSFER = 'INTERNAL_TRANSFER',
    ONLINE_SHOP = 'ONLINE_SHOP',
    REIMBURSEMENT = 'REIMBURSEMENT',
    SAVINGS_INVESTMENT_INCOME = 'SAVINGS_INVESTMENT_INCOME',
    INSURANCE_INCOME = 'INSURANCE_INCOME',
    OTHER_NON_REGULAR_INCOME = 'OTHER_NON_REGULAR_INCOME',
    UNCATEGORIZED_INCOME = 'UNCATEGORIZED_INCOME',
    PROPERTY_INSURANCE = 'PROPERTY_INSURANCE',
    PIP_INSURANCE = 'PIP_INSURANCE',
    COSMETICS_AND_APPEARANCE = 'COSMETICS_AND_APPEARANCE',
    LIFE_INSURANCE = 'LIFE_INSURANCE',
    ACCIDENT_INSURANCE = 'ACCIDENT_INSURANCE',
    HEALTH_INSURANCE = 'HEALTH_INSURANCE',
    RISK_LIFE_INSURANCE = 'RISK_LIFE_INSURANCE',
    TRAVEL_INSURANCE = 'TRAVEL_INSURANCE',
    CASH_WITHDRAWAL = 'CASH_WITHDRAWAL',
    PRIVATE_CONTRIBUTION = 'PRIVATE_CONTRIBUTION',
    AMAZON = 'AMAZON',
    GOOGLE = 'GOOGLE',
    ONLINE_SHOPS = 'ONLINE_SHOPS',
    WEB_SERVICES = 'WEB_SERVICES',
    CRYPTOCURRENCY = 'CRYPTOCURRENCY',
    INVESTMENTPLAN = 'INVESTMENTPLAN',
    NOBLE_METAL = 'NOBLE_METAL',
    PENSION_INSURANCE = 'PENSION_INSURANCE',
    PENSION_INVESTMENT = 'PENSION_INVESTMENT',
    EXTERNAL_TRANSFERS = 'EXTERNAL_TRANSFERS',
    TAXES = 'TAXES',
    COLLECTION = 'COLLECTION',
    DONATIONS_ASSOCIATION = 'DONATIONS_ASSOCIATION',
    LIABILITY_INSURANCE = 'LIABILITY_INSURANCE',
    PAYMENT_PROTECTION_INSURANCE = 'PAYMENT_PROTECTION_INSURANCE',
    INCOME_PROTECTION_INSURANCE = 'INCOME_PROTECTION_INSURANCE',
    CRYPTO_INCOME = 'CRYPTO_INCOME',
    INVESTMENT_INCOME = 'INVESTMENT_INCOME',
    SAVINGS_INCOME = 'SAVINGS_INCOME',
    BANK_INFO = 'BANK_INFO',
    LEGAL_INSURANCE = 'LEGAL_INSURANCE',
    PET_INSURANCE = 'PET_INSURANCE',
    DISABILITY_INSURANCE = 'DISABILITY_INSURANCE',
    CYBER_INSURANCE = 'CYBER_INSURANCE',
}
